import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { assertProductionMode } from "./lib/build-guard";
import { initObservability } from "./lib/observability";
import "./index.css";

assertProductionMode();
initObservability();

// Stale-chunk self-heal (class-27): a deploy transition renames hashed assets and
// dynamic imports fail with vite:preloadError. Reload ONCE (sessionStorage guard),
// and clear the guard after a successful boot so future transitions also heal.
const STALE_CHUNK_RELOAD_FLAG = "coaching_dashboard_stale_chunk_reload";
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  if (!sessionStorage.getItem(STALE_CHUNK_RELOAD_FLAG)) {
    sessionStorage.setItem(STALE_CHUNK_RELOAD_FLAG, "1");
    window.location.reload();
  }
});
window.setTimeout(() => {
  sessionStorage.removeItem(STALE_CHUNK_RELOAD_FLAG);
}, 0);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
